/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateProjectItemTaskCommand } from '../../models/update-project-item-task-command';
import { UpdateProjectItemTaskCommandResult } from '../../models/update-project-item-task-command-result';

export interface ApiProjectItemsTasksUpdateProjectItemTaskPost$Plain$Params {
      body?: UpdateProjectItemTaskCommand
}

export function apiProjectItemsTasksUpdateProjectItemTaskPost$Plain(http: HttpClient, rootUrl: string, params?: ApiProjectItemsTasksUpdateProjectItemTaskPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateProjectItemTaskCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectItemsTasksUpdateProjectItemTaskPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UpdateProjectItemTaskCommandResult>;
    })
  );
}

apiProjectItemsTasksUpdateProjectItemTaskPost$Plain.PATH = '/api/ProjectItemsTasks/UpdateProjectItemTask';
